import { Filters } from '@src/entities/Criteria/ui/components/Filters';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import React from 'react';

/**
 * Widget: AdditionalCriteria
 *
 * Displays a list of additional criteria filters to apply to an api request.
 *
 * @param filterKey
 * @param form
 * @param isCollapsible
 * @returns {Element}
 * @constructor
 */
export function AdditionalCriteria({ filterKey = 'filters', form = {}, isCollapsible = false }) {
  return (
    <ErrorHandler location="src/widgets/Criteria/AdditionalCriteria/AdditionalCriteria.jsx">
      <Widget
        backgroundColor="var(--abyss-colors-gray1)"
        collapsible={isCollapsible}
        icon="control_point_duplicate"
        title="Additional Criteria"
      >
        <Filters filterKey={filterKey} form={form} />
      </Widget>
    </ErrorHandler>
  );
}
